import { InjectionToken } from "@angular/core";

export const SIDE_PANEL_DATA = new InjectionToken<unknown>("SIDE_PANEL_DATA");
